import { defineFcm } from '../shared/factory';

export const FCM_SAP_DECISION_MAKER_EXPERIMENT = defineFcm('sap_decision_maker_experiment')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		// Locale-scoped so the experiment can run per locale (en-US first); unset locales fall to the
		// `false` default.
		supportedGroups: { locales: true },
		context: 'Start a Petition V2 (SAP) decision maker step experiment',
		description:
			'Gates the sap_decision_maker_experiment step experiment on the Start a Petition flow, and is the on/off switch for attaching DMI-inferred decision makers at publish. When on, inferred decision makers are attached for every group (control, fake_control, variant); the variant also shows the decision maker UI. When off, there is no decision maker UI and nothing is attached.',
	});
